import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-TVFSX0RCH5'); // Replace with your Measurement ID
};

// Enhanced page view tracking
export const trackPageView = (path, title) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title || document.title  // Fallback to document title
  });
};

// For React Router integration
export const trackRouterPageView = (location) => {
  trackPageView(
    location.pathname + location.search, 
    document.title
  );
};